module.exports = __webpack_public_path__ + "img/Flag_of_Norway.aff23055.svg";